export default __webpack_public_path__ + "static/media/horse.13bc42a6.png";